<template>
    <div class="campaignContainer">
        <div v-if="apiErrorMessage" class="errorContainer"> 
            <div class="errorHeading">{{ `${showBannerError ? 'Backend' : ''} Error`}}</div>
            <div class="apiErrorMessage">{{ apiErrorMessage }}</div>
        </div>
        <div
            class="campaignDetails"
            :class="((saveBtnClicked && showAdgroups) || 
                (campaignClass === 'Privilege' && (role === 'BRAND' || role === 'SELLER'))) ? 'disableCampaign' : ''"
        > 

            <div class="title">Campaign Details
                <img @mouseover="showInfo=true" @mouseleave="showInfo=false" src="../assets/info.svg"/>
            </div>
            <div  v-show="showInfo" class="hover"> 
                <div class="triangle"> </div>
                <div class="title hoverState"> Display text here </div>
            </div>
            <div class="section"> 
                <div class="heading">Campaign Type</div>
                <div v-if="campaignClass === 'Sponsored'" class="typeWrapper">
                    <div class="wrapper"> 
                        <div> 
                            <div class="subtitle">Sponsored Products</div>
                        </div>
                        <img class="sponsored" src="../assets/sponsored.svg"/>
                    </div>
                </div>
                <div v-else class="subtitle">Privilege Products</div>
            </div>
            <div class="section"> 
                <div v-if="((!this.campaignName || !this.isValidName()) && ( validationErrorMessageForName))" style="margin: unset; margin-bottom: 1%" class="errorContainer"> 
                    
                    <div v-if="validationErrorMessageForName"  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ validationErrorMessageForName }}</div>
                </div>
                <div class="heading required">Campaign Name</div>
                <div class="content"> 
                    <input class="textbox" name="campaignName" v-model="campaignName" @input="onInputChange"  placeholder="Name of the campaign" />
                </div>
            </div>
    
            <div class="section"> 
                <div v-if="((((!this.editCampaign &&  ((!this.isValidDateTime(this.startDate) || (!this.Lifetime && !this.isValidDateTime(this.endDate))))) || (this.editCampaign && ((!this.Lifetime && !this.isValidDateTime(this.endDate))))) && this.validationErrorMessageForDate))" style="margin: unset; margin-bottom: 1%" class="errorContainer"> 
                    <div  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessageForDate }}</div>
                </div>
                <div class="heading required">Campaign Date</div>
                <div class="content"> 
                    <div class="calendar">
                            <input class="textbox" type="date" id="fromDate" style="margin-right: 12px; cursor: pointer; width: 130px;" placeholder="Start Date" v-model="startDate" :min="minDate">
                            <div style="margin: 0 13px">to</div>
                            <input class="textbox" type="date" id="toDate" :disabled="isDateDisabled" style="margin-right: 12px; cursor: pointer; width: 130px;" placeholder="end Date" :min="startDate" v-model="endDate">
                        <input v-if="campaignClass !== 'Privilege'" :class="this.campaignData?.state == 6 ? 'disableCampaign' : ''" name="Lifetime" type="checkbox" @change="onLifeTimeClick" style="margin-left: 35px; cursor: pointer;" class="checkbox" id="Lifetime" value="Lifetime" v-model="Lifetime">
                        <label v-if="campaignClass !== 'Privilege'" class="lifetime" for="Lifetime">Lifetime</label>
                    </div>
                </div>
            </div>

            <div class="section"> 
                <div v-if="(this.validationErrorMessage && ((targetingType === 'Category' || targetingType === 'Product')  && !cpm))" style="margin: unset; margin-bottom: 1%" class="errorContainer"> 
                    <div  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessage }}</div>
                </div>
                <div class="heading">Targeting Type</div>
                    <div> 
                        <div v-if="campaignClass === 'Sponsored'" class="checkboxClass">
                            <div v-bind:class="targetingType === 'Keyword' ? '' : 'inactiveClass'"> 
                                <input id="Keyword" :disabled="this.isKeywordDisabled"  type="radio" value="Keyword" v-model="targetingType">
                                <label class="radioBtn" for="Keyword">Keyword</label>
                            </div>

                            <div> 
                                <div v-bind:class="targetingType === 'Category' ? 'activeClass' : targetingType === 'Keyword' ? '' : 'inactiveClass'"> 
                                    <input id="Category" :disabled="this.isCategoryDisabled" type="radio" value="Category" v-model="targetingType">
                                    <label class="radioBtn" for="Category">Category</label>
                                </div>

                                <div v-if="targetingType === 'Category'"> 
                                    <div class="heading">Bid Price</div>
                                    <div  class="budget"> 
                                        <img class="currencyIcon" src="../assets/currencyIcon.svg"> <input name="cpm" type="number" min="0" oninput="validity.valid || (value = parseFloat(value));" class="textbox" v-model="cpm" @input="onDailyBudgetChange" placeholder="Bid price" />
                                    </div>
                                </div>
                            </div>
                            <div  v-if="enablePdp"> 
                                <div v-bind:class="targetingType === 'Product' ? 'activeClass' : targetingType === 'Keyword' ? '' : 'inactiveClass'"> 
                                    <input id="Product" :disabled="this.isProductDisabled" type="radio" value="Product" v-model="targetingType">
                                    <label class="radioBtn" for="Product">Product</label>
                                </div>
                                
                                <div v-if="targetingType === 'Product'  "> 
                                    <div class="heading">Bid Price</div>
                                    <div  class="budget"> 
                                        <img class="currencyIcon" src="../assets/currencyIcon.svg"> <input name="cpm" type="number" min="0" oninput="validity.valid || (value = parseFloat(value));" class="textbox" v-model="cpm" @input="onDailyBudgetChange" placeholder="Bid price" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="checkboxClass">
                            
                            <div>
                                
                                <div v-bind:class="targetingType === 'Keyword' ? 'activeClass' : 'inactiveClass'">
                                    <input id="Keyword" :disabled="this.isKeywordDisabled"  type="radio" value="Keyword" v-model="targetingType">
                                    <label class="radioBtn" for="Keyword">Keyword</label>
                                </div>
                                <div v-if="targetingType === 'Keyword'">
                                        <div class="heading required">CPD</div>
                                        <div  class="budget">
                                            <img class="currencyIcon" src="../assets/currencyIcon.svg">
                                            <input
                                                name="cpd"
                                                type="number"
                                                min="0"
                                                oninput="validity.valid || (value = parseFloat(value));"
                                                class="textbox"
                                                v-model="cpd"
                                                placeholder="CPD"
                                                :disabled="editCampaign && campaignData?.state !== 6"
                                            />
                                            
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div v-bind:class="targetingType === 'Category' ? 'activeClass' : 'inactiveClass'">
                                        <input id="Category" :disabled="this.isCategoryDisabled" type="radio" value="Category" v-model="targetingType">
                                        <label class="radioBtn" for="Category">Category</label>
                                    </div>

                                    <div v-if="targetingType === 'Category'">
                                        <div class="heading">CPD</div>
                                        <div  class="budget">
                                            <img class="currencyIcon" src="../assets/currencyIcon.svg">
                                            <input
                                                name="cpd"
                                                type="number"
                                                min="0"
                                                class="textbox"
                                                v-model="cpd"
                                                placeholder="CPD"
                                                :disabled="editCampaign && campaignData?.state !== 6"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="validationErrorMessageForCPM && (!cpm) && campaignClass === 'Privilege'" style="margin: unset; margin-bottom: 1%; margin-top: 1%;" class="errorContainer"> 
                            <div  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ validationErrorMessageForCPM }}
                            </div>
                        </div>

                    <div style="margin-top: 16px">
                        <div v-if="(privilegeTag == '' || !/^[a-zA-Z]+$/.test(privilegeTag)) && (validationErrorMessageForTag || validationErrorMessage) && (campaignClass === 'Privilege')" style="margin: unset; margin-bottom: 1%" class="errorContainer"> 
                            <div v-if="validationErrorMessage"  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessage }} m</div>
                            <div v-if="validationErrorMessageForTag"  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessageForTag }}</div>
                        </div>
                        <div v-if="campaignClass === 'Privilege'" class="heading required">Privilege Tag</div>
                        <div v-if="campaignClass === 'Privilege'" class="content">
                            <input class="textbox" name="privilegeTag" v-model="privilegeTag" placeholder="Enter tag" maxlength="20" />
                        </div>
                    </div>
            </div>
                <div v-if="(((this.pincodeFilter === 'CUSTOM' && !this.pincodesList?.length) || (this.pincodeFilter === 'EXCEPT' && !this.pincodesExcept?.length)) && this.validationErrorMessage)" style="margin: unset; margin-bottom: 1%" class="errorContainer"> 
                    <div  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessage }}</div>
                </div>
                <div class="heading">Pincode</div>
                <PincodeSelection @pincodeData="getPincodeData" :pincodeFilter="pincodeFilter" :pincodes="pincodesList" :pincodesExcept="pincodesExcept" />
    
        </div>
        <div v-if="campaignClass === 'Sponsored'" class="campaignDetails" :class="saveBtnClicked && showAdgroups ? 'disableCampaign' : ''">
            <div class="title">Campaign Budget
                <img src="../assets/info.svg"/>
            </div>
            <div class="section"> 
                <div v-if="((!this.totalBudget || (this.pacing === 'manual' && !this.dailyBudget)) && this.validationErrorMessage)" style="margin: unset; margin-bottom: 1%" class="errorContainer"> 
                    <div  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessage }}</div>
                </div>
                <div v-if="(this.budgetErrorMEssage)" style="margin: unset; margin-bottom: 1%" class="errorContainer"> 
                    <div  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.budgetErrorMEssage }}</div>
                </div>
                <div class="heading required">Total Budget</div>
                <div class="content"> 
                    <div class="budget"> 
                        <img class="currencyIcon" src="../assets/currencyIcon.svg"> <input name="totalBudget" type="number" min="0" oninput="validity.valid || (value = parseFloat(value));" class="textbox" v-model="totalBudget" @input="onDailyBudgetChange" placeholder="Type total budget" />
                    </div>
                    <div>
                        <div class="heading">Pacing</div>
                        <div  class="text"> 
                            <input  type="radio" value="asap" class="checkbox" @change="pacingChanged" v-model="pacing">
                            <label for="Asap">Asap</label>
                        </div>
                        <!-- <div  class="text"> 
                            <input  type="radio" value="evenly" class="checkbox" :disabled="isCheckboxDisabled" @change="pacingChanged" v-model="pacing">
                            <label for="Evenly">Evenly</label>
                        </div>
                        <div  class="text"> 
                            <input  type="radio" value="frontloaded" :disabled="isCheckboxDisabled" class="checkbox" @change="pacingChanged" v-model="pacing">
                            <label for="Frontloaded">Frontloaded</label>
                        </div> -->
                        <div  class="text"> 
                            <input  type="radio" value="manual" class="checkbox" @change="pacingChanged" v-model="pacing">
                            <label for="Manual">Manual</label>
                        </div>
                        <div class="pacingBudget"  :style="{ opacity: pacing === 'manual' ? 1 : 0 }"> 
                            <div class="heading required">Daily Budget</div>
                            <div class="inputClass"> 
                                <img class="currencyIcon" src="../assets/currencyIcon.svg"> <input  type="number" min="0" oninput="validity.valid || (value = parseFloat(value));" :class="this.pacing !== 'manual'?'disableClass': ''" :disabled=isDisabled name="dailyBudget" class="textbox" @input="onDailyBudgetChange" v-model="dailyBudget" placeholder="Set a daily budget" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="campaignDetails" style="display: none"> 
            <!-- <div v-if="((!this.biddingStrategy) && this.validationErrorMessage)" style="margin: unset; margin-bottom: 1%" class="errorContainer"> 
                <div  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessage }}</div>
            </div> -->
            <div class="title">Bidding Strategy
                <img src="../assets/info.svg"/>
            </div>
            <div class="section"> 
                <div class="content"> 
                    <div>
                        <div  class="text"> 
                            <input name="biddingStrategy" type="checkbox" :disabled="true" class="checkbox" id="fixed" value="Fixed" v-model="biddingStrategy">
                            <label for="fixed">Fixed</label>
                        </div>
                        <div class="bidsWrapper"> 
                            <div class="adjustBids">Adjust bids</div>
                            <div class="search">Top of search</div> 
                            <div style="display:flex; align-items:center"> 
                                <input :disabled="true" style="cursor:not-allowed" name="topOfSearch" class="textbox" v-model="topOfSearch" placeholder="0" /> <span style="margin-left: 16px">%</span>
                            </div> 
                            <div class="search">Product pages</div>
                            <div style="display:flex; align-items:center"> 
                                <input :disabled="true" style="cursor:not-allowed" name="productPages" class="textbox" v-model="productPages" placeholder="0" /> <span style="margin-left: 16px">%</span>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Ad Group -->
        <div v-if="saveBtnClicked && this.showAdgroups"> 
            <div v-for="adGroup,index in this.adGroups.filter(item => !item.delete)" :key="adGroup"> 
                <div class="adgroupWrapper"> 
                    <img v-if="adGroup?.isOpen" @click="onCollapseClick(adGroup.count+1)" class="collapseICon" src="../assets/collapseIconUp.png">
                    <img v-else @click="onCollapseClick(adGroup.count+1)" class="collapseICon" src="../assets/collapseIcon.svg">
                    <div class="header"> 
                        <div class="title adGroupTitle"># {{ index+1 }} Ad Group
                            <img class="infoIcon" src="../assets/info.svg"/>
                        </div>
                        <div v-if="getActiveAdGroupsCount() > 1" @click="deleteAdGroup(adGroup.count)" class="deleteBtn" :class="campaignClass === 'Privilege' && (role === 'BRAND' || role === 'SELLER') ? 'disableCampaign' : ''">Delete</div>
                    </div>
                        <AdGroup 
                            :key="componentKey"
                            :adGroup="this.adGroups"
                            adGroupTitle='Ad Group' 
                            :count="adGroup?.count" 
                            :isOpen="adGroup?.isOpen"
                            :clear="clearAdGroup"
                            @CsvUploadLimitExceeded="CsvUploadLimitExceededFromChild"
                            @adGroupData="getAdGroupDataFromChild"
                            @adGroupTargetingData="getTargetingDataFromChild"
                            @deleteAdgroupClicked="deleteAdGroup"
                            :campaignData="this.campaignResponse"
                            :selectedTargetingType="this.targetingType"
                            :validationErrorMessage="this.validationErrorMessage"
                            :validationErrorMessageForAdGroupName="validationErrorMessageForAdGroupName"
                            :sellerIdRole="this.sellerIdRole"
                            :prefilledData="adGroup"
                            :productsArray="adGroup?.products"
                            :searchedProductsArray="adGroup?.searchedProducts"
                            :keywordsArray="adGroup?.keywords"
                            :name="adGroup?.adGroupName"
                            :isdisabled="adGroup?.processing_status ? adGroup?.processing_status === 0 || adGroup?.processing_status === 1 : false ?? false"  
                            :adGroupState="adGroup?.adGroupState"
                            :adGroupStateMessage="adGroup?.processing_status === 0 || adGroup?.processing_status === 1 ? `This AdGroup is currently in ${adGroupState[adGroup?.processing_status]} state` : adGroup?.processing_status === 3 ? 'Last Modify Failed, please try again' : '' "
                        />
                </div>
            </div>
            <div v-if="index+1 > 1" @click="deleteAdGroup(adGroup.count)" class="deleteBtn" :class="campaignClass === 'Privilege' && (role === 'BRAND' || role === 'SELLER') ? 'disableCampaign' : ''">Delete</div>
        </div>
        <div v-if="saveBtnClicked && this.showAdgroups" class="bottomcontainer">
            <div @click="addAdGroup" class="newAdGroup" :class="campaignClass === 'Privilege' && (role === 'BRAND' || role === 'SELLER') ? 'disableCampaign' : ''">
                <img class="plusIcon" src="../assets/plusIcon.svg"> New Ad Group
            </div>
            <div
                @click="onSubmit('submit_adGroup')"
                :class="`${(this.adGroupsListData?.find(item => item.keywords[0]?.match_type === 2) || campaignClass === 'Privilege') && 
                        (role === 'BRAND' || role === 'SELLER') ? 'disabledCreateBtn' : ''} submit`"
            >
                Submit
            </div>
        </div>
        <DialogPopup
            v-if="showPopupDialog"
            @handleUserClick="handleUserClicks">
        </DialogPopup>
    </div>
</template>

<script>

import Datepicker from "vue3-datepicker";
import AdGroup from './AdGroup.vue'
import { createAdgroup, createCampaign, modifyCampaign,modifyAdgroup, getCookie, getQueryParam, getLoggedSellerId } from '../services/campaignService'
import { toRaw } from 'vue';
import { mapState, mapActions } from "vuex";
import moment from 'moment';
import { isEmpty } from 'lodash';
import { APP_SITE_ID, ADSPOTS, ADSPOTS_PDP, ENABLE_PDP, ALGOLIA_INDEX_NAME, ALGOLIA_APP_ID, ALGOLIA_API_KEY } from '../env'
import DialogPopup from './DialogPopup.vue'
import PincodeSelection from './campaign/PincodeSelection.vue';
import { algoliaClient, algoliaIndex, getProducts } from '../../AlgoliaSDK';

export default {
    name: 'CampaignDetails',
    data(){
        return {
            sellerId: '',
            counter: 0,
            showPopupDialog:false,
            pacing: this.campaignData?.budget_pacing ? this.campaignData?.budget_pacing : "asap",
            startDate: null,
            endDate: null,
            additional: [],
            additional_grouped: [],

            biddingStrategy: true,
            campaignId: this.campaignData?.id,
            jmcampaignId: this.campaignData?.jmcampaign_id,
            campaignType: null,
            campaignName: this.campaignData?.name && this.isNewCampaign ?  this.decodeString(this.campaignData?.name) + ' copy' : this.campaignData?.name ? this.decodeString(this.campaignData?.name) : null,
            totalBudget: this.campaignData?.budget_total_limit,
            dailyBudget: this.campaignData?.budget_daily_limit === -1 ? ' ' : this.campaignData?.budget_daily_limit,
            productPages: null,
            topOfSearch: null,
            showInfo: false,
            Lifetime: this.campaignData?.expire_time || this.campaignClass === 'Privilege' ? false : true,
            adGroupName: null,
            targetingType: this.campaignData.isPDP ? "Product" : this.campaignData?.ad_format_type === 1 || this.campaignClass == 'Privilege' ? "Keyword" : "Category",
            productIds: [],
            targetValues: [],
            adGroups: this.addGroupList ?? [],
            adGroupsCopy: [],
            pincodeFilter: this.campaignData?.pincodeFilter ?? "ALL",
            pincodesList: this.campaignData?.pincodeFilter === 'CUSTOM' ? this.campaignData?.pincodes : [],
            pincodesExcept: this.campaignData?.pincodeFilter === 'EXCEPT' ? this.campaignData?.pincodes : [],

            adGroupobj: {},
            adGroupList: [],
            adGroupNamesList:[],
            adGroupProductsList: [],

            clearAdGroup: false,
            apiErrorMessage: null,
            showBannerError: true,
            campaignResponse: null,
            validationErrorMessage: null,
            validationErrorMessageForDate: null,
            validationErrorMessageForTag: null,
            validationErrorMessageForName: null,
            validationErrorMessageForBid: null,
            validationErrorMessageForAdGroupName: null,
            validationErrorMessageForCPM: null,
            budgetErrorMEssage: null,
            showAdgroups: false,
            minDate: '',
            isCheckboxDisabled: false,
            cpm: this.campaignData.cpm ? this.campaignData.cpm : null,

            adGroupListFromLocalStorage: [],

            componentKey: 0,
            adGroupsListDataFromApi: null,
            isKeywordDisabled: false,
            isCategoryDisabled: false,
            isProductDisabled: false,
            adGroupStateMessage: null,
            adGroupState: {0:'Pending', 1: 'Processing', 2: 'Completed', 3:'Failed'},
            enablePdp: ENABLE_PDP === 'true' ? true : false,
            bidPrice: 0,
            matchType: '',
            role: getCookie('role'),
            cpd: this.campaignData.cpm ?? null,
            privilegeTag: this.campaignData.tag ?? "",
        }
    },
    props: {
        campaignData: {
            type: Object,
            default: () => { }
        },
        adGroupsListData: {
            type: Object,
            default: () => { }
        },
        saveBtnClicked: Boolean,
        isNewCampaign: Boolean,
        sellerIdRole: String,
        editCampaign: Boolean
    },
    computed: {
        ...mapState(['addGroupList', 'campaignClass']),
        condition() {
            return this.additional?.length > 0
        },
        final: function(){
            return this.additional.concat(this.additional_grouped);
        },
        isDisabled(){
            return this.pacing === 'manual' ? false : true;
        }
    },
    watch: {
        campaignData(newVal, oldVal){
            this.jmcampaignId = newVal.jmcampaign_id
            this.dailyBudget = newVal.budget_daily_limit
        },
        targetingType(newVal, oldVal){
            if(newVal !== oldVal){
                this.resetAdGroupListData();
                this.adGroupList = []
                this.setCurrentTargetingType(newVal);
            }
        },
        startDate(newVal, oldVal){
            let startDate = new Date(newVal), endDate = new Date(this.endDate)
            if(endDate < startDate){
                this.endDate = null;
            }
        },
        adGroupsCopy(newVal, oldVal){
            this.adgroups = this.addGroupList;
        },
    },
    mounted() {
        this.Lifetime = this.campaignData?.expire_time || this.campaignClass === 'Privilege' ? false : true
        if(this.campaignData?.start_time){
            this.startDate = new Date(this.campaignData?.start_time);
            this.startDate = this.formatDate(this.startDate)
        }
        if(this.campaignData?.expire_time){
            this.endDate = new Date(this.campaignData?.expire_time);
            this.endDate = this.formatDate(this.endDate)
        }
        const today = new Date();
        const currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        var dtToday = new Date();
        var month = dtToday.getMonth() + 1;
        var day = dtToday.getDate();
        var year = dtToday.getFullYear();
        if(month < 10)
            month = '0' + month.toString();
        if(day < 10)
        day = '0' + day.toString();
        this.minDate = year + '-' + month + '-' + day;

        this.pacingMap();
        this.isDateDisabled();
        this.sellerId = getLoggedSellerId();
        if(this.campaignData?.start_time && this.campaignData?.id){
            document.getElementById("fromDate").disabled = true;
        }
        this.adGroupsListDataFromApi = this.adGroupsListData;
        this.adGroups = this.adGroupsListData;
        if(this.Lifetime){
            this.endDate=null;
            document.getElementById("toDate").disabled = true;
            this.isCheckboxDisabled = true;
        }else{
            document.getElementById("toDate").disabled = false;
            this.isCheckboxDisabled = false;
        }
        this.targetingType = this.campaignData.isPDP ? "Product" : this.campaignData?.ad_format_type === 1 || this.campaignClass == 'Privilege' ? "Keyword" : "Category";
        if(this.targetingType === "Keyword" && this.editCampaign){
            this.isCategoryDisabled = true;
            this.isKeywordDisabled = false;
            this.isProductDisabled = true;
        }else if(this.targetingType == "Category" && this.editCampaign){
            this.isKeywordDisabled = true;
            this.isCategoryDisabled = false;
            this.isProductDisabled = true;
        }else if(this.targetingType == "Product" && this.editCampaign){
            this.isKeywordDisabled = true;
            this.isCategoryDisabled = true;
            this.isProductDisabled = false;
        }
        if(this.campaignClass === 'Privilege') {
            this.isCategoryDisabled = true;
        }

    },
    components: {
        Datepicker,
        AdGroup,
        DialogPopup,
        PincodeSelection,
    },
    methods: {
        ...mapActions(['setAdGroupListData','resetAdGroupListData','setCurrentTargetingType']),
        formatDate(value) {
            if (value) {
                const dateObj = new Date(value);
                const year = dateObj.getFullYear();
                const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Adding 1 to month as it's zero-based
                const day = String(dateObj.getDate()).padStart(2, '0');

                const formattedDate = `${year}-${month}-${day}`;
                return formattedDate;
            }
        },
        isValidName(){
            const pattern = /^[^%^₨`()."']+$/;
            const isValidName = pattern.test(this.campaignName);
            return isValidName
        },
        isValidAdGroupName(adgroupName) {
            const pattern = /^[^%^₨`,.()]+$/;
            const isValidName = pattern.test(adgroupName);
            return isValidName
        },
        onInputChange(){
            this.validationErrorMessage = null
        },
        isDateDisabled(){
            return this.lifetime;
        },
        decodeString(value){
            return atob(value)
        },
        pacingChanged(){
            this.dailyBudget = null;
        },
        getActiveAdGroupsCount(){
            const remainingGroups = this.adGroups.filter(adgroup => !adgroup.delete );
            return remainingGroups? remainingGroups.length : 0;
        },
        pacingMap(){
            if(this.pacing===1){
                this.pacing = 'asap'
            }else if(this.pacing===2){
                this.pacing = 'frontloaded'
            }else if(this.pacing===3){
                this.pacing = 'evenly'
            }else if(this.pacing===4){
                this.pacing = 'manual'
            }
        },
        addAdGroup() {
            /*this.adGroups = JSON.parse(localStorage.getItem('adGroupList')) ?? [];*/
            this.adGroups = this.addGroupList;
            let obj = {};
            obj['adGroupName'] = '';
            obj['products'] = [];
            obj['keywords'] =[];
            obj['searchedProducts']=[];
            obj['count'] = this.adGroups?.length;
            this.counter++;
            this.adGroups.push({isOpen: true, ...obj});
            this.setAdGroupListData(this.adGroups);
        },
        deleteAdGroup(count){
            this.adGroups[count].delete = true;
            this.counter--;
            this.setAdGroupListData(this.adGroups);
        },
        onCollapseClick(count){
            // this.adGroups = JSON.parse(localStorage.getItem('adGroupList')) ?? [];
            this.adGroups = this.addGroupList ?? [];
            let newarr = [...this.adGroups];
            let copyarr = {...newarr[count-1]}
            copyarr.isOpen = !newarr[count-1]?.isOpen
            newarr[count-1] = copyarr
            this.adGroups = toRaw(newarr)
            this.setAdGroupListData(this.adGroups);
            // this.adGroupListFromLocalStorage = JSON.parse(localStorage.getItem('adGroupList'));
            this.componentKey++;
            return this.adGroups;
        },
        check_one: function(){
            this.additional = [];
        },
        onLifeTimeClick(){
            if(this.Lifetime){
                this.endDate=null;
                document.getElementById("toDate").disabled = true;
                this.isCheckboxDisabled = true;
                if(this.pacing === "evenly" || this.pacing === "frontloaded"){
                    this.pacing = null
                }
            }else{
                document.getElementById("toDate").disabled = false;
                this.isCheckboxDisabled = false;
            }
        },

        isValidDateTime (dateTimeString) {
            const pattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
            if(!moment(dateTimeString, 'YYYY-MM-DD', true).isValid()){
                return false
            }
            if(dateTimeString < this.minDate){
                return false
            }
            return true;
        },

        validateCampaign(formData) {
            let isValid = true;

            let name = formData.name,
                totalBudget = formData.budget_total_limit,
                dailyBudget = formData.budget_daily_limit,
                pacing = formData.budget_pacing,
                startTime = formData.start_time,
                expire_time = formData.expire_time;

            this.validationErrorMessage = null;
            this.validationErrorMessageForTag = null;
            this.validationErrorMessageForName = null;
            this.validationErrorMessageForDate = null;
            this.validationErrorMessageForCPM = null;

            //targetting type
            if ((this.targetingType === 'Category' || this.targetingType === 'Product') &&
                this.campaignClass === 'Sponsored' && (!this.cpm)) {
                this.validationErrorMessage = 'Required field';
                isValid = false;
            }

            //cpd 
            if((this.campaignClass === 'Privilege')) {
                if(!this.cpm && !this.cpd) {
                    this.validationErrorMessageForCPM = 'CPD is required';
                    isValid = false;
                }
            }

            //tag
            if (this.campaignClass === 'Privilege') {
                if (isEmpty(this.privilegeTag)) {
                    this.validationErrorMessage = 'Required field';
                    isValid = false;
                } else if (!/^[a-zA-Z ]+$/.test(this.privilegeTag)) {
                    this.validationErrorMessageForTag = 'Enter a valid tag';
                    isValid = false;
                }
            }

            const pattern = /^[^%^₨`()."']+$/;
            const isValidName = pattern.test(atob(name));
            

            //campaign date
            if (!this.editCampaign &&
                (!this.isValidDateTime(this.startDate) || (!this.Lifetime && !this.isValidDateTime(this.endDate)))) {
                this.validationErrorMessageForDate = 'Enter a valid date';
                isValid = false;
            } else if (this.editCampaign && (!this.Lifetime && !this.isValidDateTime(this.endDate))) {
                this.validationErrorMessageForDate = 'Enter a valid date';
                isValid = false;
            }

            //pincode
            if (formData.pincodeFilter !== 'ALL' && !formData?.pincodes?.length) {
                this.validationErrorMessage = 'Required field';
                isValid = false;
            }
            
            //budget
            if (((typeof totalBudget !== 'number' ||
                    (this.pacing === 'manual' && typeof dailyBudget !== 'number') ||
                    typeof pacing !== 'number' ||
                    !isEmpty(this.budgetErrorMEssage)) )) {
                this.validationErrorMessage = 'Required field';
                isValid = false;
            }
            
            
            //campaign name
            if (isEmpty(name) || this.campaignName === null ) {
                this.validationErrorMessageForName = 'Campaign Name is required !';
                isValid = false;
                
            } else {
                if(!isValidName) {
                    this.validationErrorMessageForName = 'Campaign name should not contain ^%₹`()."';
                    isValid = false;
                }
            }
            //console.log("Is campaign valid ?  = ", isValid)
            return isValid;
        },


        validateAdgroups(formData, index){
            /*let agdroupsFromLocal = JSON.parse(localStorage.getItem('adGroupList'))*/
            let isValidAdGrp = true;
            let agdroupsFromLocal = this.addGroupList;
            let name = formData.name ? formData.name : formData.adGroupName, 
                products = formData.products, 
                keywords = formData.keywords;
            let adgroup;

            this.validationErrorMessage = null;
            this.validationErrorMessageForAdGroupName = null;
            // if(index){
               adgroup = agdroupsFromLocal?.[index];
               name = adgroup.adGroupName, products = adgroup.products, keywords = adgroup.keywords;
            // }
            console.log('fsdafas', adgroup)
            if(this.targetingType === "Keyword" && adgroup?.keywordMatch?.type !== "Broad" && isEmpty(keywords)){
                this.validationErrorMessage = 'Required field';
                isValidAdGrp = false;
            }

            //bid price 
            if(this.campaignClass !== 'Privilege' && keywords?.length && keywords.some((item) => item.bid_price == 0)) {
                this.validationErrorMessage = 'Required bid price';
                isValidAdGrp = false;
            }

            //bid price 
            const validateBidPrice = keywords.some(item => {
                if(this.dailyBudget > 0 && this.dailyBudget < item.bid_price) {
                    return true;
                } else if(this.totalBudget && item.bid_price && (this.totalBudget < item.bid_price)) {
                    return true;
                }
            })
            if(this.campaignClass !== 'Privilege' && validateBidPrice) {
                isValidAdGrp = false;
            }

            //products list
            if( isEmpty(products)){
                this.validationErrorMessage = 'Required field';
                isValidAdGrp = false;
            }

            //adgrp name
            if(isEmpty(name)) {
                this.validationErrorMessageForAdGroupName = 'Adgroup name is required !';
                isValidAdGrp = false;
            }
            else {
                if(!this.isValidAdGroupName(name)) {
                    this.validationErrorMessageForAdGroupName = 'Adgroup name should not contain ^%₹`(),';
                    isValidAdGrp = false;
                }
            }
            console.log("Is adgrp valid ?  = ", isValidAdGrp)
            return isValidAdGrp;
        },
        
        async validateCategoryLevel(adgroup) {
            let isValid = true;
            try {
                let algoliaclient = await algoliaClient(ALGOLIA_APP_ID, ALGOLIA_API_KEY);

                let algoliaindex = await algoliaIndex(algoliaclient, ALGOLIA_INDEX_NAME);
                let products;
                products = await getProducts(algoliaindex, toRaw(adgroup.products.map(item => item.productId)), this.sellerId, false, this.sellerIdRole);

                let test = Array.from(products, ([key, value]) => (value))
                test.forEach(product => {
                    let hasCategory = true;
                    if(this.targetingType !== 'Keyword') {
                        const categoryLevel = product.get('data')?.categoryLevel;
                        hasCategory = categoryLevel && Object.values(categoryLevel).length;
                        if(hasCategory) {
                            if(this.targetingType == 'Product') {
                                hasCategory = hasCategory && Object.values(categoryLevel).every(item => item?.length);
                            } else {
                                const {level4, ...levels} = categoryLevel;
                                hasCategory = hasCategory && Object.values(levels).every(item => item?.length);
                            }
                        }
                    }
                    if(!(product.get('statusCode') === 0) || !hasCategory){
                        this.apiErrorMessage = !(product.get('statusCode') === 0) ?
                             `${product.get('message')} ${product.get('data').productId}` :
                             `Category level doesn't exists for the product ${product.get('data').productId}`
                        isValid = false;
                        this.showBannerError = false;
                    }
                })

            } catch(e){
                console.log("error in getting hits: ", e)
            }
            if(isValid) {
                this.apiErrorMessage = "";
                this.showBannerError = true;
            }
            return isValid;
        },

        onDailyBudgetChange(){
            if(this.totalBudget && this.dailyBudget && (this.totalBudget < this.dailyBudget)){
                this.budgetErrorMEssage = "Daily budget cannot be greater than Total Budget"
            }else{
                this.budgetErrorMEssage = null
            }
            if(this.targetingType === "Keyword")
                return;
            if(this.totalBudget < this.cpm || this.cpm > this.totalBudget){
                this.budgetErrorMEssage = "Bid price cannot be greater than Total Budget"
            }
            if(this.dailyBudget > 0 && this.dailyBudget < this.cpm){
                this.budgetErrorMEssage = "Bid price cannot be greater than Daily Budget"
            }
        },  
        async onSubmit(action) {

            let budget_pacing;
            if(this.pacing==="asap"){
                budget_pacing = 1
            }else if(this.pacing==='frontloaded'){
                budget_pacing = 2
            }else if(this.pacing==='evenly'){
                budget_pacing = 3
            }else if(this.pacing==='manual'){
                budget_pacing = 4
            }
            let actionQueryParam;

            if(action==='submit_campaign'){
                actionQueryParam = 'submit'
            }else{
                actionQueryParam = 'save'
            }

            if(action === 'submit_adGroup'){
                let queryParams = 'submit'
                // let agdroupsFromLocal = JSON.parse(localStorage.getItem('adGroupList'))
                let agdroupsFromLocal = this.addGroupList;
                let areAdGroupsValid = true;
                if(agdroupsFromLocal.length > 0){
                    agdroupsFromLocal.map((adgroup, index) => {
                        if(!adgroup.delete && !this.validateAdgroups(adgroup, index)){
                            areAdGroupsValid = false;
                        }
                    })
                }
                if(areAdGroupsValid){
                    if(this.editCampaign){
                        this.modifyAdgroupAPI(queryParams)
                    }else{
                        this.createAdGroupAPI(queryParams)
                    }
                     }
            }else {
                this.apiErrorMessage = null;
                const now = new Date();
                const startDate = new Date(this.startDate);

                // Set start time to current time if it's today, otherwise set it to midnight
                let startTime;

                if (startDate.toDateString() === now.toDateString()) {
                    const currentHour = now.getHours().toString().padStart(2, '0'); 
                    const currentMinute = now.getMinutes().toString().padStart(2, '0');
                    const currentSecond = now.getSeconds().toString().padStart(2, '0');
                    startTime = `${currentHour}:${currentMinute}:${currentSecond}`;
                } else {
                    startTime = '00:00:00';
                }

                const startDateString = moment(this.startDate).format('YYYY-MM-DD');
                const startDateTimeString = `${startDateString} ${startTime}`;

                let params = {
                        id: this.campaignId && !this.isNewCampaign ? this.campaignId : null,
                        jmcampaign_id: this.jmcampaignId,
                        isPDP: this.targetingType === "Product" ? true : false,
                        channel_id: 4,
                        objective: 13,
                        campaign_type: [3],
                        ad_format_type: this.targetingType === "Keyword" ? 1 : 2,
                        deal_type: this.campaignClass === 'Privilege'? 'Roadblock' : "Directdeals",
                        app_site_id: APP_SITE_ID,
                        adspots: this.targetingType === "Product" ? JSON.parse(ADSPOTS_PDP) : [ADSPOTS],
                        sellerid:  this.sellerId,
                        new_revenue_type: this.campaignClass === 'Privilege' ? 4 : 2,
                        cpm: this.campaignClass === 'Privilege' ? this.cpd : 
                            this.targetingType === 'Category' || this.targetingType === 'Product'  ? this.cpm : 10.58,
                        isPrivileged: this.campaignClass === 'Privilege',
                        tag: this.privilegeTag ?? "sponsored",
                        weight: 12,
                        checksum: 0,
                        name: btoa(this.campaignName),
                        ...(this.campaignData?.state !== 6 && {start_time: startDateTimeString}),
                        ...(this.campaignData?.state !== 6 && {expire_time: this.endDate ? moment(this.endDate).format('YYYY-MM-DD 23:59:59') : ""}),
                        ...(this.campaignClass !== 'Privilege' && {budget_total_limit: this.totalBudget > 0 ? this.totalBudget : null}),
                        ...(this.campaignClass !== 'Privilege' && {budget_daily_limit: this.dailyBudget > 0 ? this.dailyBudget : -1}),
                        ...(this.campaignClass !== 'Privilege' && {budget_pacing: budget_pacing  > 0 ? budget_pacing : this.pacing === 'asap' ? -1 : null}),
                        pincodeFilter: this.pincodeFilter,
                        pincodes: this.pincodeFilter === 'ALL' ? [] : this.pincodeFilter === 'CUSTOM' ? this.pincodesList : this.pincodesExcept,
                        campaignCreatedBy: this.campaignData?.campaignCreatedBy ?? getCookie('userId'),
                    }
                    console.log(params, this.campaignClass);

                    let queryParams = action==='submit_campaign' ? 'submit' : 'save';
                    let createAPICall;

                    if(!this.campaignId && this.jmcampaignId && action==='save_as_draft'){
                        createAPICall = false; //calls modify api
                        queryParams = 'save';
                        //create -> submit, not save
                    }else if(this.campaignId && this.jmcampaignId && action==='save_as_draft'){
                        createAPICall = false;
                        queryParams = 'save';
                    }else if(!this.campaignId && this.jmcampaignId && action==='submit_campaign'){
                        createAPICall = true; //calls create api
                        queryParams = 'submit';
                    }else if(this.jmcampaignId && this.campaignId){
                        //disable save button
                        createAPICall = false; //calls modify api
                        queryParams = 'submit';
                    }else{
                        createAPICall = true; //calls create api
                        queryParams = action==='submit_campaign' ? 'submit' : 'save';
                    }

                        //console.log('asdf', queryParams, createAPICall)
                    if(this.validateCampaign(params) && createAPICall){
                        this.createCampaignAPI(params, queryParams)
                    }else if(this.validateCampaign(params)){
                        this.modifyCampaignAPI(params, queryParams)
                    }
            }
        },
        async modifyAdgroupAPI(queryParams){
            /* let agdroupsFromLocal = JSON.parse(localStorage.getItem('adGroupList')) */
            let agdroupsFromLocal = this.addGroupList;
            // this.adgroups = JSON.parse(localStorage.getItem('adGroupList'))
            if(agdroupsFromLocal.length > 0){
                agdroupsFromLocal.map(async (adgroup, index) => {
                    const valid = await this.validateCategoryLevel(adgroup);
                    if(this.validateAdgroups(adgroup, index) && valid){

                        let adGroup = agdroupsFromLocal[index];

                        let isDelete = false;
                        if(adGroup.delete){
                            delete adGroup.keywords;
                            delete adGroup.products;
                            isDelete = true
                        }

                        adGroup?.keywords?.map(keyword => {
                            if(!keyword.id){
                                keyword['create'] = true
                            }
                        })
                        let params = {
                            ...adGroup,
                            da: 1,
                            channel_id: 4,
                            state: adGroup?.delete ? 2 : null,
                            products_count: adGroup?.delete ? null : adGroup?.products_count,
                            keywords_count: adGroup?.delete ? null : adGroup?.keywords_count,
                            keywords: adGroup?.keywords?.length ? adGroup.keywords[0].match_type === 2 ? [{...adGroup.keywords[0], keyword: '',match_type: 2,bid_price: adGroup.keywords[0].bid_price}] : adGroup?.keywords : [],
                        }

                        if(isDelete){
                            delete params.da
                        }


                        if(adGroup?.processing_status !== 1 && adGroup?.processing_status !==0 && adGroup?.jm_adgroup_id){
                            modifyAdgroup(params, queryParams)
                            .then(res=> res.json())
                            .then(data => {
                                if((!isEmpty(data?.status) && data?.status !== 200) || !isEmpty(data?.errorResponse?.message) || !isEmpty(data?.errorCode)){
                                    this.apiErrorMessage = data?.error || data?.errorResponse?.message || data?.errorMessageList[0] || data?.errorCode
                                }else{
                                    this.$emit('submitclicked'); //redirection
                                }
                            })
                        }else if(!adGroup.delete && !adGroup?.jm_adgroup_id){
                            console.log(adGroup)
                            let params = {
                                channel_id: 4,
                                jmflg: 1,
                                checksum: 2541180320,
                                campaign_id: this.campaignId ? this.campaignId : this.campaignResponse ? this.campaignResponse.id : null,
                                products: adGroup?.products?.map(item => {
                                    return {productId: item.productId}
                                }),
                                keywords: adGroup.keywordMatch?.type == "Broad" ? [{keyword: "",match_type: 2,bid_price: adGroup.keywordMatch.bid}] : adGroup.keywords,
                                name: adGroup?.adGroupName,
                                sellerid: this.sellerId,
                                jmcampaign_id: this.jmcampaignId,
                            }
                            createAdgroup(params, queryParams)
                            .then(res=> res.json())
                            .then(data => {
                                if((!isEmpty(data?.status) && data?.status !== 200) || !isEmpty(data?.errorResponse?.message) || !isEmpty(data?.errorCode)){
                                    this.apiErrorMessage = data?.error || data?.errorResponse?.message || data?.errorMessageList[0] || data?.errorCode
                                }else{
                                    this.$emit('submitclicked'); //redirection
                                }
                            })
                        }
                    }
                })
            }
        },
        async createAdGroupAPI(queryParams){
            /* let agdroupsFromLocal = JSON.parse(localStorage.getItem('adGroupList')) */
            let agdroupsFromLocal = this.addGroupList;
            if(!isEmpty(agdroupsFromLocal)){
                const apicalls = agdroupsFromLocal.map((adgroup, index) => {
                    let params = {
                        channel_id: 4,
                        jmflg: 1,
                        campaign_id: this.campaignResponse ? this.campaignResponse.id : null, //no campaign id for cloned adgroup creation with save action
                        products: adgroup?.products?.map(item => {
                            return {productId: item.productId}
                        }),
                        keywords: adgroup?.keywordMatch?.type == "Broad" ? [{keyword: "",match_type: 2,bid_price: adgroup.keywordMatch.bid}] : adgroup.keywords,
                        name: adgroup.adGroupName,
                        sellerid: this.sellerId,
                        jmcampaign_id: this.jmcampaignId,
                        //adgroup id
                        //jm campaign id
                    }

                    if(this.validateAdgroups(params, index) && !adgroup.jm_adgroup_id && !adgroup.delete){
                        createAdgroup(params, queryParams)
                        .then(res=> res.json())
                        .then(data => {
                            if((!isEmpty(data?.status) && data?.status !== 200) || !isEmpty(data?.errorResponse?.message) || !isEmpty(data?.errorCode)){
                                this.apiErrorMessage = data?.error || data?.errorResponse?.message || data?.errorMessageList[0] || data?.errorCode
                            }else if(!isEmpty(data?.sellerid)){
                                this.$emit('submitclicked'); //redirection
                            }
                        })
                    }
                })

                // Promise.all(apicalls).then((results) => {
                //     console.log(results, 'adgroup results')
                // })
            }else{
                let params = {
                        channel_id: 4,
                        jmflg: 1,
                        checksum: 2541180320,
                        campaign_id: this.campaignId ? this.campaignId : this.campaignResponse ? this.campaignResponse.id : null,
                        products: this.productIds.map(item => {
                            return {productId: item.productId}
                        }),
                        keywords: this.targetValues[0]?.match_type == 2 ? [{keyword: "",match_type: 2,bid_price: this.targetValues[0].bid_price}] : this.targetValues,
                        name: this.adGroupName,
                        sellerid: this.sellerId,
                        jmcampaign_id: this.jmcampaignId,
                        //adgroup id
                        //jm campaign id
                    }

                    if(this.validateAdgroups(params)){
                        createAdgroup(params, queryParams)
                        .then(res=> res.json())
                        .then(data => {
                            if((!isEmpty(data?.status) && data?.status !== 200) || !isEmpty(data?.errorResponse?.message) || !isEmpty(data?.errorCode)){
                                this.apiErrorMessage = data?.error || data?.errorResponse?.message || data?.errorMessageList[0] || data?.errorCode
                            }else if(!isEmpty(data?.sellerid)){
                                this.$emit('submitclicked'); //redirection
                            }
                        })
                    }
            }
        },
        async createCampaignAPI(params, queryParams){
            let response;
                response = await createCampaign(params, queryParams)
                                    .then(res => res.json())
                                    .then(data => {
                                        if(data?.errorResponse?.message || data?.errorMessageList?.length){
                                            this.$emit('validationCheck', false);
                                            this.apiErrorMessage = data?.errorResponse?.message || data?.errorMessageList[0]
                                            this.showAdgroups = false;
                                        }
                                        else if(!isEmpty(data?.sellerid)){
                                            this.jmcampaignId = data?.jmcampaign_id
                                            this.campaignId = data?.id
                                            this.campaignResponse = data;
                                            this.showAdgroups = true;
                                            this.$emit('validationCheck', true);

                                            if( queryParams === 'submit'){
                                                let obj = {};
                                                obj['adGroupName'] = '';
                                                obj['products'] = [];
                                                obj['keywords'] =[];
                                                obj['count'] = 0;
                                                obj['searchedProducts']=[];
                                                obj['isOpen'] = true;
                                                this.adGroupsListData.push(obj);
                                                this.setAdGroupListData(this.adGroupsListData);
                                            }
                                        }
                                    })
                                    .catch(error => {
                                        this.apiErrorMessage = error?.response?.data?.errorResponse?.message
                                    })
                // this.campaignResponse = response.data
                //console.log("Res = ",response)
        },
        async modifyCampaignAPI(params, queryParams){
            let response;
                response = await modifyCampaign(params, queryParams)
                                    .then(res => res.json())
                                    .then(data => {
                                        if(data?.errorMessageList?.length > 0){
                                            this.$emit('validationCheck', false);
                                            this.apiErrorMessage = data?.errorMessageList?.[0]
                                            this.showAdgroups = false;
                                        }else if(!isEmpty(data?.sellerid)){
                                            this.campaignResponse = data;
                                            this.$emit('updateName', this.decodeString(data?.name))
                                            this.showAdgroups = true;
                                            this.jmcampaignId = data?.jmcampaign_id
                                            this.campaignId = data?.id
                                            this.$emit('validationCheck', true);
                                        }
                                    })
                                    .catch(error => {
                                        this.apiErrorMessage = error?.response?.data?.errorResponse?.message
                                    })
        },
        onFormClear(){
            this.$emit('submitclicked');
            this.campaignName = null;
            this.startDate = null;
            this.totalBudget = this.dailyBudget = this.pacing  = null;
            this.endDate=null;
            this.Lifetime= null;
            this.clearAdGroup = true;
        },
        getAdGroupDataFromChild({ adGroupName, productIds,count, searchedProducts,isOpen }){
            /* const existingAdGrps = JSON.parse(localStorage.getItem('adGroupList')) ?? []; */
            const existingAdGrps = this.addGroupList;
            this.adGroupName = adGroupName;
            this.productIds = toRaw(productIds);
            // if(!this.adGroupName){
            //     return
            // }
            if(!this.adGroupNamesList.includes(adGroupName)){
                this.adGroupNamesList.push(adGroupName)
            }
            let obj = existingAdGrps[count] ? existingAdGrps[count] : {};
            obj['adGroupName'] = this.adGroupName;
            obj['products'] = this.productIds;
            obj['count'] = count;
            obj['isOpen'] = isOpen;
            obj['searchedProducts']=searchedProducts;

            this.adGroupList[count] = obj;
            this.adGroupsCopy = existingAdGrps;
            // this.adGroups = existingAdGrps;
            existingAdGrps[count] = obj
            this.setAdGroupListData(existingAdGrps);
        },

        getTargetingDataFromChild({ adGroupName,targetingValues,count, suggestions, keywordMatch }){
            this.targetValues = toRaw(targetingValues)
            /* const existingAdGrps = JSON.parse(localStorage.getItem('adGroupList')) ?? []; */
            const existingAdGrps = this.addGroupList;
            let obj = existingAdGrps[count] ? existingAdGrps[count] : {};
            obj['adGroupName'] = adGroupName;
            obj['keywords'] = this.targetValues;
            obj['count'] = count;
            obj['isOpen'] = true;
            obj['suggestions'] = toRaw(suggestions) ?? existingAdGrps[count].suggestions ?? [];
            obj['keywordMatch'] = keywordMatch ?? existingAdGrps[count].keywordMatch ?? {};

            if(this.targetingType === 'Keyword'){
                this.adGroupList.push(obj);
                this.adGroups = existingAdGrps;
                this.componentKey++;
                existingAdGrps[count] = obj
                this.setAdGroupListData(existingAdGrps);
            }
            // this.adGroupListFromLocalStorage = JSON.parse(localStorage.getItem('adGroupList'));

        },
        CsvUploadLimitExceededFromChild(value){
            this.showPopupDialog = value;
        },
        handleUserClicks(value){
            this.showPopupDialog = false;
        },
        getPincodeData(filter, list) {
            this.pincodeFilter = filter;
            if(list) {
                if (filter === 'CUSTOM') {
                    this.pincodesList = list;
                } else {
                    this.pincodesExcept = list;
                }
            }
        }
    }
}

</script>

<style scoped>
@font-face {
    font-family: "Inter-Regular";
    src: url('../assets/fonts/Inter-Regular.ttf');
}

.checkboxClass{
    display: flex;
    align-items: center;
}

.radioBtn{
    margin-right: 170px;
}

.errorContainer{
    background: #FDEDED;
    border-radius: 8px;
    margin: 1%;
    padding: 18px 24px;
}

.errorHeading{
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    color: #EB5757;
    /* margin-bottom: 12px; */
    display: flex;
}

.apiErrorMessage{
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: #666666;
    margin-top: 12px;
}
.disableClass{
    cursor: not-allowed;
}
 .newAdGroup{
        cursor: pointer;
        margin: 25px 20px 25px 20px;
        padding: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFFFFF;
        border: 1px dashed #D3D3D3;
        border-radius: 12px;
    }

    .adgroupWrapper{
        position: relative;
        margin-bottom: 24px
    }

    .lifetime{
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        color: #41434C;
    }

    .plusIcon{
        margin-right: 20px;
    }

.campaignContainer{
    display: flex;
    flex-direction: column;
}

.header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #E0E0E0;
        /* padding: 0 24px; */
        padding: 22px 24px 22px;
        background: #FFFFFF;
        margin-left: 14px;
    }

    .infoIcon{
        margin-left: 10px;
    }

    .collapseICon{
        width: 26px;
        height: 26px;
        position: absolute;
        top: -12px;
        right: 30px;
        cursor: pointer;
        z-index: 1;
    }


    .adGroupTitle{
        margin: 0 1%;
        display: flex;
        /* justify-content: space-between; */
        align-items: center;
        width: 100%;
        border-bottom: unset !important;
        margin-bottom: unset !important;
        padding-bottom: unset !important;
    }
.deleteBtn{
        font-weight: 700;
        font-size: 14px;
        line-height: 21px;
        text-align: center;
        color: #A80000;
        padding: 5px 36px;
        border: 1px solid #A80000;
        background: #FFFFFF;
        border-radius: 4px;
        cursor: pointer;
        /* margin-bottom: 10px; */
    } 
    .submit{
        font-style: normal;
        font-weight: 700;
        font-size: 20.4818px;
        line-height: 25px;
        color: #FFFFFF;
        padding: 16px;
        background: #2E31BE;
        border-radius: 12px;
        /* max-width: 1189px; */
        text-align: center;
        margin: 25px 0 25px 20px;
        cursor: pointer;
    }
    .campaignDetails{
        display: flex;
        flex-direction: column;
        margin:1%;
        text-align: start;
        background: #FFFFFF;
        padding: 22px 24px 36px;
        border-radius: 12px;
    }

    .budget{
        display: flex;
    }

    .pacingBudget{
        padding-left: 26px;
        border-left: 1px solid #E4E5E6;
    }
    
    .inputClass{
        display: flex;
    }

    .currencyIcon{
        padding: 12px;
        background: #F2F2F2;
    }
    .typeWrapper{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .calendar{
        display: flex;
        align-items: center;
        width: 100%;
    }

    .text{
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        color: #41434C;
        text-align: center;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        margin-left: 14px;
    }

    .checkbox{
        margin-right: 8px;
        width: 20px;
        height: 20px;
    }

    .bidsWrapper{
        margin-left: 14px;
        padding-left: 26px;
        border-left: 1px solid #E4E5E6;
        width: 100%;    
        text-align: start;
    }
    .search{
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        color: #333333;
        margin: 8px 0 8px;
    }

    .adjustBids{
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: -0.005em;
        color: #333333;
        margin-bottom: 4px;
    }
    .section{
        margin-bottom: 36px;
    }
    .section:last-child{
        margin-bottom: unset;
    }

    .info{
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.005em;
        color: #B4B4B4;
        padding-left: 20px;
        border-left: 3px solid #B4B4B4;
        max-width: 290px;
    }

    .content{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 60%;
    }

    .textbox{
        font-family: "Inter-Regular";
        width: 100%;
        padding: 8px 12px;
        font-weight: 400;
        font-size: 12px;
        line-height: 26px;
        /* color: #9B9B9B; */
        background: #FFFFFF;
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        max-width: 246px;
    }

    .title{
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.01em;
        color: #666666;
        padding: 22px 0;
        padding-top: 0;
        border-bottom: 1px solid #E0E0E0;
        margin-bottom: 32px;

        position: relative;
    }

    


    .hoverState{
        position: absolute;
        left: 500px;
        bottom: 540px;
        background: #273238;
        border-radius: 4px;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        color: #F5F5F7;
        padding: 16px;
    }
    .triangle{
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 20px solid #273238;
        border-bottom: 10px solid transparent;

        position: absolute;
        left: 480px;
        bottom: 586px;
    }



    .wrapper{
        background: #FFFFFF;
        border: 2.49242px solid #2E31BE;
        border-radius: 9.9697px;
        max-width: 328px;
        padding: 15px;
        display: flex;
    }

    .sponsored{
        margin-left: 7px;
    }
    .subtitle{
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #41434C;
        margin-bottom: 12px;
    } 

    .description{
        font-weight: 400;
        font-size: 9.9697px;
        line-height: 17px;
        color: #9B9B9B;
    }

    .heading{
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #333333;
        margin-bottom: 12px;
    }

    .bottomcontainer{
        /* display: flex; */
        flex-direction: column;
    }

    .inactiveClass{
        margin-bottom: 90px;
    }


    .activeClass{
        margin-bottom: 16px;
    }
    .disableCampaign {
        pointer-events: none;
    }
    .disabledCreateBtn {
        opacity: 0.4;
        cursor: not-allowed;
        pointer-events: none;
    }

    .required::after {
        content: '*';
        color: #eb5757; 
        margin-left: 4px; 
        font-weight: bold;
    }
</style>

